import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { AccordionSummaryStyled } from './WorkAccordion.style';
import styles from '../../styles/Praca.module.scss';

const WorkAccordion = ({ id, job }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { title, head, content, foot } = job;

  return (
    <Accordion
      className={
        isExpanded
          ? `${styles.accordion} ${styles.activeAccordion}`
          : styles.accordion
      }
      expanded={isExpanded}
    >
      <AccordionSummaryStyled
        className={styles.accordionSummary}
        key={id}
        id={id}
        onClick={() => setIsExpanded(!isExpanded)}
        isExpanded={isExpanded}
      >
        <Typography className={styles.title}>{title}</Typography>
      </AccordionSummaryStyled>
      <AccordionDetails>
        <Typography className={styles.contentContainer}>
          {ReactHtmlParser(head)}
          {ReactHtmlParser(content)}
          {ReactHtmlParser(foot)}
        </Typography>
        <button
          className={styles.showLess}
          onClick={() => setIsExpanded(false)}
        >
          Zobacz mniej <img src='/darkBlueArrow.svg' />
        </button>
      </AccordionDetails>
    </Accordion>
  );
};

export default WorkAccordion;
